<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog :close-on-click-modal="false" title="催缴" :show-close="true" :visible="true"
    :before-close="handleBeforeClose" width="660px">
    <div class="dialog__container">
      <div style="padding-bottom: 16px;">
        <el-button size="mini" type="primary" class="plr28" @click="handleAdd">添加</el-button>
        <el-button size="mini" type="primary" class="plr28" plain @click="handleDelete">删除</el-button>
      </div>

      <el-table @selection-change="handleSelectionChange" max-height="430px" v-loading="tableLoading" :data="list"
        border style="width: 100%">
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column show-overflow-tooltip prop="makeDate" label="催缴时间" width="120"></el-table-column>
        <el-table-column show-overflow-tooltip prop="remark" label="备注" width="100"></el-table-column>
        <el-table-column label="操作" width="160px" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleEditDict(scope.row)">编辑</el-button>
            <div class="btn-divide"></div>
            <el-button size="mini" type="text" @click="handleDeleteDict(scope.row)">删除</el-button>
          </template>
        </el-table-column>

      </el-table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="plr28" size="mini" type="info" plain @click="handleCancel">取消</el-button>
      <el-button class="plr28" type="primary" size="mini" @click="handleConfirm">确定</el-button>
    </span>
    <el-dialog :close-on-click-modal="false" :title="status === 'add' ? '新增催款' : '编辑催款'" :show-close="true"
      :visible="dialogVisible" :before-close="handleBeforeClose2" width="660px" append-to-body>
      <div>
        <el-form inline ref="form" class="search-form" label-position="right" :model="form" :rules="rules"
          label-width="70px">
          <el-form-item label="催缴时间:" prop="makeDate" class="input-with-col2 mr0">
            <el-date-picker v-model="form.makeDate" size="mini" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
              unlink-panels clearable></el-date-picker>
          </el-form-item>
          <el-form-item label="备注：" class="input-with-col2 mr0" prop="remark">
            <el-input size="mini" v-model.trim="form.remark" placeholder="请输入备注" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="plr28" size="mini" type="info" plain @click="handleCancel2">取消</el-button>
        <el-button class="plr28" type="primary" size="mini" :loading="loadBtn" @click="handleConfirm2">确定</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
  import {
    getReceiveReminderList,
    deleteReceiveReminder,
    saveReceiveReminder
  } from '@/api/ReceiveReminder'

  export default {
    props: {
      detail: {
        required: true
      },
      appCode: {
        type: String
      }
    },
    data() {
      return {
        resourceTypeList: [],
        dialogVisible: false,
        tableLoading: false,
        list: [],
        multipleSelection: [],
        status: 'add',
        parentArr: [],
        parentIdNew: '',
        form: {
          makeDate: '',
          remark: ''
        },
        rules: {
          makeDate: [{
            required: true,
            message: '请选择催缴时间',
            trigger: 'blur'
          }],
          remark: [{
            required: true,
            message: '请输入备注',
            trigger: 'blur'
          }]
        },
        loadBtn: false
      }
    },
    methods: {

      // 多选
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      async getListData() {
        this.tableLoading = true
        let queryData = {
          pageIndex: 1,
          pageSize: 10000,
          financialReceiveId: this.detail.id
        }
        const res = await getReceiveReminderList(queryData)
        if (res.code === 200) {
          this.list = [...res.data.list]
        }
        this.tableLoading = false
      },
      handleAdd() {
        this.status = 'add'
        this.form = {
          makeDate: '',
          remark: ''
        }
        this.dialogVisible = true
      },
      handleEditDict(row) {
        this.status = 'edit'
        this.form = {
          ...row
        }
        this.dialogVisible = true
      },
      // 多行删除
      handleDelete() {
        if (this.multipleSelection && this.multipleSelection.length === 0) {
          this.$message.warning('请至少选择一行')
          return
        }
        this.$confirm('确定删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            let ids = []
            this.multipleSelection.forEach(item => {
              ids.push(item.id)
            })
            deleteReceiveReminder({
              idList: ids
            }).then(res => {
              if (res && res.code === 200) {
                this.$message.success('删除成功')
                this.getListData()
              }
            })
          })
          .catch(() => {})
      },
      // 单行删除
      handleDeleteDict(row) {
        this.$confirm('确定删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            deleteReceiveReminder({
              idList: [row.id]
            }).then(res => {
              if (res && res.code === 200) {
                this.$message.success('删除成功')
                this.getListData()
              }
            })
          })
          .catch(() => {})
      },
      handleBeforeClose(done) {
        this.$emit('cancel')
        done()
      },
      handleBeforeClose2(done) {
        this.dialogVisible = false
        done()
      },
      handleCancel() {
        this.$emit('cancel')
      },
      async handleConfirm() {
        this.$emit('confirm')
      },
      handleCancel2() {
        this.dialogVisible = false
      },
      handleConfirm2() {
        if (this.loadBtn) return
        this.$refs['form'].validate(async valid => {
          if (valid) {
            this.loadBtn = true
            if (this.status === 'add') {
              this.form.financialReceiveId = this.detail.id
              saveReceiveReminder({
                ...this.form
              }).then(res => {
                if (res.code === 200) {
                  this.dialogVisible = false
                  this.getListData()
                }
                this.loadBtn = false
              })
            } else if (this.status === 'edit') {
              saveReceiveReminder({
                ...this.form
              }).then(res => {
                if (res.code === 200) {
                  this.dialogVisible = false
                  this.getListData()
                }
                this.loadBtn = false
              })
            }
          }
        })

      }
    },
    created() {
      this.getListData()
    },
    mounted() {
      this.getListData()
    }
  }
</script>

<style scoped lang="scss">
  .dialog__container {
    .class_box {
      display: flex;
      margin-bottom: 20px;
      font-size: 12px;

      span {
        color: #CCCCCC;
      }

      .class_box_span_last {
        color: #666666;
        font-weight: 600;
      }

      .class_box_symbol {
        margin: 0 5px;
        color: #CCCCCC;
      }

    }

  }
</style>



// WEBPACK FOOTER //
// src/pages/ReceiveManagement/components/ReminderList.vue